/* eslint-disable global-require */

const socials = [
  {
    name: 'GitHub',
    href: 'https://github.com/alexpuente0',
    icon: require('../assets/github.png'),
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/alex-puente-farias/',
    icon: require('../assets/linkedin.png'),
  },
  {
    name: 'Medium',
    href: 'https://medium.com/@zero.con.z',
    icon: require('../assets/them.png'),
  },
];

export default socials;
